import { lazyLoad } from 'utils/loadable';

export const ActiveUserGroupPage = lazyLoad(
  () => import('./index'),
  module => module.ActiveUserGroupPage,
);
